import React, { useCallback, useEffect, useRef } from "react";

export function useMobileKeyboardFocus(shouldFocus: boolean) {
  const proxyInputRef = useRef<HTMLInputElement>(null);
  const targetRef = useRef<HTMLInputElement>(null);

  useEffect(() => {
    if (shouldFocus && targetRef.current) {
      targetRef.current.focus();
    }
  }, [shouldFocus]);

  const triggerFocus = useCallback(() => {
    proxyInputRef.current?.focus();
  }, []);

  const ProxyInput = useCallback(
    () => (
      <input
        ref={proxyInputRef}
        tabIndex={-1}
        style={{
          position: "absolute",
          opacity: 0,
          height: 0,
          width: 0,
          padding: 0,
          border: "none",
          overflow: "hidden",
        }}
      />
    ),
    [],
  );

  return { targetRef, triggerFocus, ProxyInput } as const;
}
